"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOW_CART_INFO = exports.CANCEL_FETCH = exports.FETCH_FILES_FAILURE = exports.FETCH_FILES_SUCCESS = exports.FETCH_FILES = exports.iFetchItemsSuccessData = exports.iDeserializeSuccessData = exports.TOGGLE_CART = exports.CLEAR_ALL = exports.FETCH_ITEMS_SUCCESS = exports.FETCH_ITEMS_FAILURE = exports.FETCH_ITEMS_REQUEST = exports.DESERIALIZE_SUCCESS = exports.DESERIALIZE_FAILURE = exports.DESERIALIZE_REQUEST = exports.SERIALIZE_SUCCESS = exports.SERIALIZE_FAILURE = exports.SERIALIZE_REQUEST = exports.REMOVE_ITEMS = exports.ADD_ITEMS = void 0;
const t = require("io-ts");
const TypesLib = require("@caddigital/sok-types");
exports.ADD_ITEMS = '@sok/cart/ADD_ITEMS';
exports.REMOVE_ITEMS = '@sok/cart/REMOVE_ITEMS';
exports.SERIALIZE_REQUEST = '@sok/cart/SERIALIZE_REQUEST';
exports.SERIALIZE_FAILURE = '@sok/cart/SERIALIZE_FAILURE';
exports.SERIALIZE_SUCCESS = '@sok/cart/SERIALIZE_SUCCESS';
exports.DESERIALIZE_REQUEST = '@sok/cart/DESERIALIZE_REQUEST';
exports.DESERIALIZE_FAILURE = '@sok/cart/DESERIALIZE_FAILURE';
exports.DESERIALIZE_SUCCESS = '@sok/cart/DESERIALIZE_SUCCESS';
exports.FETCH_ITEMS_REQUEST = '@sok/cart/FETCH_ITEMS_REQUEST';
exports.FETCH_ITEMS_FAILURE = '@sok/cart/FETCH_ITEMS_FAILURE';
exports.FETCH_ITEMS_SUCCESS = '@sok/cart/FETCH_ITEMS_SUCCESS';
exports.CLEAR_ALL = '@sok/cart/CLEAR_ALL';
exports.TOGGLE_CART = '@sok/cart/TOGGLE_CART';
exports.iDeserializeSuccessData = t.array(t.union([TypesLib.File._iFolderMinimal, TypesLib.File._iRevisionMinimal]));
exports.iFetchItemsSuccessData = t.interface({
    data: exports.iDeserializeSuccessData
});
exports.FETCH_FILES = '@sok/cart/FETCH_FILES';
exports.FETCH_FILES_SUCCESS = '@sok/cart/FETCH_FILES_SUCCESS';
exports.FETCH_FILES_FAILURE = '@sok/cart/FETCH_FILES_FAILURE';
exports.CANCEL_FETCH = '@sok/cart/CANCEL_FETCH';
exports.SHOW_CART_INFO = '@sok/cart/SHOW_CART_INFO';
//# sourceMappingURL=cart.js.map